import React from 'react';
import Modal from 'react-bootstrap/Modal';
// import activatePush from 'services/activatePush';

interface MonitoringPushModalProps {
  pushEnabled: string | undefined;
  monitoringNotificationModalOpened: boolean;
  setMonitoringNotificationModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const MonitoringPushModal = (props: MonitoringPushModalProps) => {
  const { pushEnabled, monitoringNotificationModalOpened, setMonitoringNotificationModalOpened } =
    props;

  return (
    <Modal show={monitoringNotificationModalOpened}>
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          <strong>
            {pushEnabled === 'default' ? 'Permitir Notificações' : 'Desbloquear Notificações'}
          </strong>
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setMonitoringNotificationModalOpened(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div className="modal-body">
        {pushEnabled === 'denied'
          ? 'Para receber notificações de novas mensagens clique em "Permitir" acima.'
          : 'O acesso à notificações está bloqueado. Você deve ir nas configurações do navegador para desbloquear. Depois de configurado, atualize a página.'}
      </div>

      <div className="modal-footer">
        <button
          type="button"
          data-dismiss="modal"
          className="btn btn-primary"
          onClick={() => {
            // activatePush();
            setMonitoringNotificationModalOpened(false);
          }}
        >
          Entendi
        </button>
      </div>
    </Modal>
  );
};

export default MonitoringPushModal;
